<!-- #86 -->
<template>
  <v-col class="mx-4 py-0 mt-2">
    <div class="d-flex">
      <div
        class="text-h6 py-0 my-0 pl-0"
        style="color: #23468c; font-weight: 500; width: 100%"
      >
        Pre Alert
      </div>
      <v-spacer></v-spacer>
      <v-btn
        small
        color="primary"
        class="mr-9"
        @click="$router.push('/addPreAlert')"
        >Add Pre Alert</v-btn
      >
    </div>
    <v-divider class="mt-1 mb-4"></v-divider>
    <v-dialog
      v-model="orderdetailsPopup"
      max-width="980px"
      close-delay="ma-5"
      @keydown.esc="orderdetailsPopup = false"
    >
      <v-card>
        <v-card-title>
          List | {{ this.opendetailsData.client_id }} |
          {{ this.opendetailsData.mawb_no }} |
          {{ this.opendetailsData.origin_id }}-->{{
            this.opendetailsData.destination_id
          }}
          <v-spacer></v-spacer>
          <v-icon @click="(orderdetailsPopup = false), (opendetailsData = {})"
            >mdi-close</v-icon
          >
        </v-card-title>
        <v-divider class="my-4"></v-divider>
        <v-card-text>
          <v-data-table
            :headers="detailsHeaders"
            :items="detailsData"
            :options.sync="optionsDetails"
            :server-items-length="totals"
            :loading="rsaLoader"
            class="elevation-1"
            :items-per-page="100"
            :footer-props="{
              itemsPerPageOptions: [100, 250],
              showFirstLastPage: true,
              firstIcon: 'mdi-arrow-collapse-left',
              lastIcon: 'mdi-arrow-collapse-right',
              prevIcon: 'mdi-minus',
              nextIcon: 'mdi-plus',
            }"
          >
            <template v-slot:[`item.hawb`]="{ item }">
              <label
                @click="fetchTrackingDetails(item.hawb)"
                v-if="checkPermission('app_client:tracking_details')"
              >
                <a>{{ item.hawb }}</a>
              </label>
              <label v-else>{{ item.hawb }}</label>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-data-table
      :headers="_headers"
      :items="list"
      :options.sync="options"
      :server-items-length="total"
      :loading="loader"
      class="elevation-1 mt-7 pr-5"
      :items-per-page="25"
      :footer-props="{
        itemsPerPageOptions: [25, 50, 100, 250],
        showFirstLastPage: true,
        firstIcon: 'mdi-arrow-collapse-left',
        lastIcon: 'mdi-arrow-collapse-right',
        prevIcon: 'mdi-minus',
        nextIcon: 'mdi-plus',
      }"
    >
      <template v-slot:[`item.action`]="{ item }">
        <v-tooltip
          bottom
          v-if="checkPermission('app_manifest:pre_alerts_shipment_order_list')"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              small
              class="mr-2"
              v-bind="attrs"
              v-on="on"
              @click="openDetails(item)"
            >
              mdi-eye
            </v-icon>
          </template>
          <span>View</span>
        </v-tooltip>
        <v-tooltip
          bottom
          v-if="checkPermission('app_manifest:prealert_manifest_format')"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              small
              class="mr-2"
              v-bind="attrs"
              v-on="on"
              @click="downloadPreAlert(item)"
            >
              mdi-download
            </v-icon>
          </template>
          <span>Download</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              small
              v-if="item.mawb_file"
              class="mr-2"
              v-bind="attrs"
              v-on="on"
              @click="downloadmMawb(item)"
            >
              mdi-receipt
            </v-icon>
          </template>
          <span>Download Mawb File</span>
        </v-tooltip>
      </template>
      <template v-slot:top>
        <template>
          <v-form>
            <v-row class="custom-row pl-5 pr-5">
              <v-col cols="12" sm="3" v-if="userCategory.user_category == 3">
                <v-autocomplete
                  v-model="selectedClient"
                  :items="clients"
                  :loading="clientLoader"
                  hide-no-data
                  outlined
                  item-text="name"
                  item-value="id"
                  label="Select Client"
                  placeholder="Start typing to Search"
                  class="pb-0 pt-0 text-center"
                  @focus="fetchClientList"
                  hide-details
                  dense
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="3">
                <v-text-field
                  label="MAWB Number"
                  v-model="mawb_no"
                  outlined
                  hide-details
                  dense
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="3">
                <v-menu
                  v-model="dateFilter"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      :value="getFormattedDate(departure_date)"
                      label="Departure Date"
                      append-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      outlined
                      clearable
                      hide-details
                      dense
                      @click:clear="clearInput('departure_date')"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="departure_date"
                    @input="dateFilter = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="12" sm="3">
                <v-menu
                  v-model="dateFilterarrival"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      :value="getFormattedDate(arrival_date)"
                      label="Arrival Date"
                      append-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      outlined
                      clearable
                      @click:clear="clearInput('arrival_date')"
                      hide-details
                      dense
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="arrival_date"
                    @input="dateFilterarrival = false"
                    hide-details
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="12" sm="3">
                <v-menu
                  v-model="dateCreatedFrom"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      :value="getFormattedDate(created_date_from)"
                      label="Created From"
                      append-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      outlined
                      clearable
                      @click:clear="clearInput('created_date_from')"
                      hide-details
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="created_date_from"
                    @input="dateCreatedFrom = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="12" sm="3">
                <v-menu
                  v-model="dateCreatedto"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      :value="getFormattedDate(created_date_to)"
                      label="Created To"
                      append-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      outlined
                      clearable
                      @click:clear="clearInput('created_date_to')"
                      hide-details
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="created_date_to"
                    @input="dateCreatedto = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="12" sm="3">
                <v-text-field
                  label="HAWB Number"
                  v-model="hawb"
                  outlined
                  hide-details
                ></v-text-field>
              </v-col>
              <v-col
                :cols="userCategory.user_category == 3 ? 3 : 6"
                class="text-right"
              >
                <v-btn class="success" color="primary" @click="searchAll"
                  >Search</v-btn
                >
                <v-btn color="white" class="ml-4" @click="allClear"
                  >Clear</v-btn
                >
              </v-col>
            </v-row>
          </v-form>
          <v-divider class="my-5"></v-divider>
        </template>
      </template>
      <template v-slot:[`item.arrival_date`]="{ item }">
        <template v-if="item.arrival_date">
          {{ item.arrival_date | localMomentNew | moment("DD MMM, YYYY") }}
        </template>
      </template>
      <template v-slot:[`item.actual_arrival_date`]="{ item }">
        <template v-if="item.actual_arrival_date">
          {{
            item.actual_arrival_date
              | localMomentformat
              | moment("DD MMM, YYYY HH:mm:ss")
          }}
          {{ item.timezone }}
        </template>
        <a v-else @click="opencalenderFunction(item)"
          ><v-icon
            v-if="checkPermission('app_manifest:pre_alerts_arrival_date_list')"
            >mdi-calendar-account-outline</v-icon
          ></a
        >
      </template>
      <template v-slot:[`item.departure_date`]="{ item }">
        <template v-if="item.departure_date">
          {{ item.departure_date | localMoment | moment("DD MMM, YYYY") }}
        </template>
      </template>
    </v-data-table>
    <v-dialog
      v-model="opencalender"
      max-width="550px"
      close-delay="ma-5"
      @keydown.esc="opencalender = false"
    >
      <v-card>
        <v-toolbar flat style="height: 55px">
          <v-toolbar-title>
            Arrival Date <i class="caption red--text ml-4"> * required field</i>
          </v-toolbar-title>
        </v-toolbar>
        <span class="pl-4 pt-0">Timezone : {{ timmeZone }}</span>

        <v-divider class="my-2"></v-divider>

        <v-card-text class="pl-1">
          <v-form ref="formdate" lazy-validation>
            <div class="text-left py-0 pl-4">
              <label> <b>MAWB Number : </b>{{ mawbNumber }}</label>
              <br />
              <label
                ><b>Destination Country :</b> {{ destinationCountry }}</label
              >
              <v-col cols="12" sm="12" class="custom-dialog pl-0">
                <template>
                  <v-menu
                    v-model="menuVisible"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="600px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        :value="newrcvDateTime"
                        label="Date and Time"
                        append-icon="mdi-calendar-clock"
                        readonly
                        class="required"
                        v-bind="attrs"
                        :hide-details="errorMessage == false ? false : true"
                        outlined
                        :rules="[(v) => !!v || 'Date and Time is required.']"
                        v-on="on"
                      ></v-text-field>
                    </template>

                    <v-dialog v-model="menuVisible" width="600px">
                      <v-card>
                        <v-card-text class="px-0 py-0">
                          <v-row class="mx-0 my-0">
                            <v-col cols="6" class="py-0 px-0">
                              <v-date-picker
                                v-model="rcvDateTime"
                                :max="getEndDate"
                              ></v-date-picker>
                            </v-col>
                            <v-col cols="6" class="custom-picker px-0 py-0">
                              <v-time-picker
                                v-model="timeValue"
                                full-width
                                :ampm="false"
                                format="HH:mm:ss"
                              ></v-time-picker>
                            </v-col>
                          </v-row>
                        </v-card-text>
                        <v-card-actions class="px-0 py-0 pl-0">
                          <v-btn
                            color="primary"
                            text
                            @click="(menuVisible = false), setvalue()"
                            >OK</v-btn
                          >
                        </v-card-actions>
                      </v-card>
                    </v-dialog>
                  </v-menu>
                </template>
              </v-col>
              <span style="color: red" v-if="errorMessage"
                >Please select date & time properly
              </span>
              <div class="text-left ml-0">
                <v-btn small color="primary" @click="updateOrder()"
                  >Update</v-btn
                >
                <v-btn small color="white" class="ml-4" @click="cancel"
                  >Cancel</v-btn
                >
              </div>
            </div>
          </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-col>
</template>
<script>
import { mapActions, mapGetters } from "vuex";

export default {
  data: () => ({
    rcvDateTime: "",
    menuVisible: false,
    detailsData: [],
    saveLoader: false,
    injectionType: [
      { text: "Transit via DXB", value: 0 },
      { text: "Direct", value: 1 },
    ],
    orderdetailsPopup: false,
    selectedClient: "",
    dateMenu: false,
    dateMenuFrom: false,
    dateFilter: false,
    dateFilterarrival: false,
    dateCreatedto: false,
    dateCreatedFrom: false,
    rcvDate: null,
    dateMenuRcv: false,
    chargedAmount: null,
    receiveAmount: null,
    transactionNumberFill: null,
    orderItem: {},
    dateFilterD: false,
    dateFilterA: false,
    departure_date: null,
    arrival_date: null,
    loader: false,
    filePVerify: null,
    file: null,
    downloader: false,
    uploaderPUpload: false,
    uploadResDialog: false,
    uploadRes: {},
    dialog: false,
    exitdialog: false,
    boe_no: null,
    boeexitLoader: false,
    fileLoader: false,
    fileDocLoader: false,
    fileDataLoader: false,
    addDialog: false,
    headers: [
      {
        text: "Client",
        value: "client_id",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
      {
        text: "Mawb No",
        value: "mawb_no",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
      {
        text: "Origin",
        value: "origin_id",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
      {
        text: "Destination",
        value: "destination_id",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
      {
        text: "Estimated Departure Date",
        value: "departure_date",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
      {
        text: "Estimated Arrival Date",
        value: "arrival_date",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
      {
        text: "Actual Arrival Date",
        value: "actual_arrival_date",
        class: "body-1 font-weight-bold",
        sortable: false,
      },

      {
        text: "Total Shipments",
        value: "total_shipments",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
      {
        text: "Total Number of bags",
        value: "total_unique_bags",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
      {
        text: "Weight (In Kg)",
        value: "total_weight",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
      {
        text: "Flight No",
        value: "flight_no",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
      {
        text: "Action",
        value: "action",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
    ],
    detailsHeaders: [
      {
        text: "Bag Number",
        value: "bag_no",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
      {
        text: "HAWB",
        value: "hawb",
        class: "body-1 font-weight-bold",
        sortable: false,
      },

      {
        text: "Unique Auto Bag Number",
        value: "unique_auto_bag_no",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
      {
        text: "Weight (In kg)",
        value: "weight",
        sortable: false,

        class: "body-1 font-weight-bold",
      },
    ],
    list: [],
    options: {},
    optionsDetails: {
      page: 1,
      itemsPerPage: 100,
      sortDesc: [false],
    },
    total: 0,

    receipt: "",
    detailsPopup: false,
    mawb_no: null,
    hawb: null,
    clients: [],
    transactionDate: "",
    status: "",
    carrier: "",
    opencalender: false,
    rsaLoader: false,
    totals: 0,
    itemFound: {},
    payment_id: null,
    editedIndex: -1,
    orderdetailsRow: false,
    previusPage: false,
    countries: [],
    created_date_from: null,
    created_date_to: null,
    mawbNumber: null,
    destinationCountry: null,
    selecteditem: {},
    errorMessage: false,
    newrcvDateTime: "",
    timeValue: "",
    opendetailsData: "",
  }),

  watch: {
    dialog(val) {
      val || this.close();
    },
    options: {
      handler() {
        this.fetchpreALertList();
      },
      deep: true,
    },
    optionsDetails: {
      handler() {
        if (this.optionsDetails.page !== 1 || this.previusPage) {
          this.previusPage = true;
          if (this.item !== undefined) this.openDetails(this.item);
        }
      },
      deep: true,
    },
  },
  created() {
    this.fetchClientList();
  },
  computed: {
    ...mapGetters(["userCategory"]),

    _headers() {
      return this.headers.filter((i) =>
        this.userCategory.user_category !== 3 ? i.value !== "client_id" : true
      );
    },
    getEndDate() {
      var endDate = new Date();
      endDate.setDate(endDate.getDate() + 1);
      endDate.setHours(0, 0, 0, 0); // Set hours, minutes, seconds, and milliseconds to zero
      return endDate.toISOString().split("T")[0]; // Keep only the date part
    },
  },
  methods: {
    ...mapActions([
      "snackBar",
      "getPrealertList",
      "fetchClient",
      "addPreAlert",
      "preAlertorderDetails",
      "downloadPrealertTemplate",
      "downloadPreAlertData",
      "downloadMawbfile",
      "getdateDetails",
      "updatedateDetails",
    ]),
    fetchTrackingDetails(item) {
      window.open(
        this.$router.resolve({
          name: "ClientTrackingDetails",
          query: {
            id: item,
          },
        }).href,
        "_blank"
      );
    },
    setvalue() {
      if (
        this.timeValue == undefined ||
        this.timeValue == null ||
        this.timeValue == "" ||
        this.rcvDateTime == ""
      ) {
        this.errorMessage = true;
      } else {
        this.errorMessage = false;
      }
      let date = this.getFormattedDate(this.rcvDateTime);
      if (date == null || (date == "" && this.timeValue == "")) {
        this.errorMessage = false;
        this.newrcvDateTime = "";
      } else {
        this.newrcvDateTime = `${date} ,  ${this.timeValue}`;
      }
    },
    updateOrder() {
      if (!this.$refs.formdate.validate()) return;

      if (this.errorMessage == false) {
        let date = `${this.rcvDateTime} ${this.timeValue}:00`;
        const payload = new FormData();
        payload.append("actual_arrival_date", date);
        this.updatedateDetails({
          id: this.selecteditem.id,
          data: payload,
        })
          .then((res) => {
            this.snackBar({
              color: "success",
              message: res.data.message,
            });
            this.opencalender = false;
            this.fetchpreALertList();
            this.newrcvDateTime = "";
            this.rcvDateTime = "";
            this.timeValue = "";
          })
          .catch(() => {
            this.opencalender = false;
          });
      }
    },
    opencalenderFunction(item) {
      this.selecteditem = item;
      this.getdateDetails(item.id).then((res) => {
        this.destinationCountry = res.data.records[0].destination_country;
        this.mawbNumber = res.data.records[0].mawb_no;
        this.timmeZone = res.data.records[0].timezone;
        this.opencalender = true;
      });
    },
    cancel() {
      (this.selecteditem = {}), (this.opencalender = false);
      this.newrcvDateTime = "";
      this.rcvDateTime = "";
    },
    fetchClientList() {
      if (this.clients.length) return;
      if (this.clients.length === 0 && this.userCategory.user_category === 3) {
        this.clientLoader = true;
        this.fetchClient({
          fields: "id,name",
          pagination: 0,
          service: "clickdna",
        })
          .then((res) => {
            this.clientLoader = false;
            this.clients = res.data;
          })
          .catch(() => {
            this.clientLoader = false;
          });
      }
    },
    openDetails(item) {
      this.opendetailsData = item;
      let id;
      if (this.item == undefined) {
        this.itemFound = item;
        this.item = item;
        id = item.id;
      } else {
        id = item.id;
      }
      let data = {
        id: id,
        options: this.optionsDetails,
      };
      this.preAlertorderDetails(data).then((res) => {
        this.detailsData = res.data.records;
        this.orderdetailsPopup = true;
        this.totals = res.data.total;
      });
    },
    downloadmMawb(item) {
      let url = item.mawb_file;
      this.downloadMawbfile(url)
        .then((res) => {
          this.fileDownload(res, "pdf");
          this.downloader = false;
        })
        .catch(() => {
          this.downloader = false;
        });
    },
    downloadPreAlert(item) {
      let payload = {
        prealert_shipment_id: item.id,
      };

      this.downloadPreAlertData(payload)
        .then((res) => {
          this.fileDownload(res);
          this.downloader = false;
        })
        .catch(() => {
          this.downloader = false;
        });
    },
    closeDetailsPopup() {
      this.detailsPopup = false;
      this.fetchpreALertList();
      this.allClear();
    },
    clearInput(val) {
      if (val == "departure_date") {
        this.departure_date = "";
      } else if (val == "arrival_date") {
        this.arrival_date = "";
      } else if (val == "created_date_from") {
        this.created_date_from = "";
      } else if (val == "created_date_to") {
        this.created_date_to = "";
      }
    },
    allFilters() {
      this.loader = true;
      let obj = {
        client_id: this.selectedClient,
        mawb_no: this.mawb_no,
        departure_date: this.departure_date,
        arrival_date: this.arrival_date,
        hawb: this.hawb,
        created_date_from: this.created_date_from,
        created_date_to: this.created_date_to,
      };
      Object.keys(obj).forEach((key) => {
        if (obj[key] === null || obj[key] === undefined || obj[key] === "") {
          delete obj[key];
        }
      });
      this.filtersArr = obj;
    },
    searchAll() {
      this.options.page = 1;
      this.allFilters();
      this.getPrealertList({ ...this.options, ...this.filtersArr })
        .then((res) => {
          this.loader = false;
          this.list = res.data.records;
          this.total = res.data.total;
        })
        .catch(() => {
          this.loader = false;
        });
    },
    allClear() {
      this.selectedClient = "";
      this.mawb_no = null;
      this.departure_date = null;
      this.arrival_date = null;
      this.hawb = null;
      this.filtersArr = [];
      this.created_date_from = null;
      this.created_date_to = null;
      this.fetchpreALertList();
    },

    fetchpreALertList() {
      this.list = [];
      this.loader = true;
      this.getPrealertList({ ...this.options, ...this.filtersArr })
        .then((res) => {
          this.loader = false;
          this.list = res.data.records;

          this.total = res.data.total;
        })
        .catch(() => {
          this.loader = false;
        });
    },
    reset() {
      this.file = "";
      this.boe_no = "";
      this.addDialog = false;
      this.dialog = "";
      this.$refs.form?.reset();
      this.$refs.form1?.reset();
      this.formData = {};
      this.editedIndex = -1;
      this.orderdetailsRow = false;
    },

    close() {
      this.dialog = false;
      this.exitdialog = false;
      this.allClear();
    },
  },
};
</script>
<style>
.v-date-picker-title {
  height: 70px !important;
}
</style>
